import React from "react";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import MailOutlinedIcon from "@mui/icons-material/MailOutlined";
import logo from "../assets/images/dramrishlogo.png";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
const Footer = () => {
  return (
    <div className="bg-[#17543E] w-full pt-9 pb-1.5 flex justify-center items-center ">
      <div className="2xl:w-[70%] xl:w-[80%] w-[90%] mt-10 ">
        <div className="flex md:flex-row flex-col p-3 w-full border-b-[1px] border-[#588d7996] pb-16">
          <div className="md:w-1/3 w-full flex lg:flex-row flex-col items-center lg:items-start gap-8 text-white">
            <div className="flex-shrink-0">
              <SupportAgentIcon className="text-[50px]" />
            </div>
            <div className="text-center lg:text-left">
              <h3 className="text-[#BDEAD9] font-playfair text-3xl mb-2.5">
                24/7 Phone Answer
              </h3>
              <p className="text-[#BDEAD9] font-raleway text-xl mb-2.5">
                1-800-123-4567
              </p>
              <p className="text-[#BDEAD9] font-raleway text-xl mb-2.5">
                1-800-123-4567
              </p>
            </div>
          </div>

          <div className="md:w-1/3 w-full md:my-0 my-3 flex lg:flex-row flex-col items-center lg:items-start gap-8 text-white">
            <div className="flex-shrink-0">
              <LocationOnOutlinedIcon className="text-[50px]" />
            </div>
            <div className="text-center lg:text-left">
              <h3 className="text-[#BDEAD9] font-playfair text-3xl mb-2.5">
                Main Center
              </h3>
              <p className="text-[#BDEAD9] font-raleway text-xl mb-2.5">
                2480 Newberry Rd Waterford,
              </p>
              <p className="text-[#BDEAD9] font-raleway text-xl mb-2.5">
                Michigan(MI), 48329, United States
              </p>
            </div>
          </div>

          <div className="md:w-1/3 w-full flex lg:flex-row flex-col items-center lg:items-start gap-8 text-white">
            <div className="flex-shrink-0">
              <MailOutlinedIcon className="text-[50px]" />
            </div>
            <div className="text-center lg:text-left">
              <h3 className="text-[#BDEAD9] font-playfair text-3xl mb-2.5">
                Mailing Address
              </h3>
              <p className="text-[#BDEAD9] font-raleway text-xl mb-2.5">
                contact@example.com
              </p>
              <p className="text-[#BDEAD9] font-raleway text-xl mb-2.5">
                sales@example.com
              </p>
            </div>
          </div>
        </div>

        <div className="flex justify-center items-center pt-6 pb-6 flex-col">
          {/* <div className="w-[300px] h-40 flex justify-center items-center">
            <img src={logo} alt="logo" />
          </div> */}
          <div className="flex justify-center items-center gap-3 mt-3">
            <span className="w-12 h-12 rounded-full bg-[#DCEBE4] flex justify-center items-center text-[#17543e]"><FacebookOutlinedIcon /></span>
            <span className="w-12 h-12 rounded-full bg-[#DCEBE4] flex justify-center items-center text-[#17543e]"><XIcon /></span>
            <span className="w-12 h-12 rounded-full bg-[#DCEBE4] flex justify-center items-center text-[#17543e]"><LinkedInIcon/></span>
            <span className="w-12 h-12 rounded-full bg-[#DCEBE4] flex justify-center items-center text-[#17543e]"><InstagramIcon /></span>
          </div>

          <h3 className="mt-16 text-[16px] text-[#89CEB4]">
          Copyright 2025 NovaTales © All rights reserved
          </h3>
        </div>
      </div>
    </div>
  );
};

export default Footer;
